import React from 'react';

import { useComposablePage } from '../../../../helpers/composable';
import withBrandedComposablePage from '../../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../../layouts/ComposablePageLayout';
import ArticlePageQuery from './ArticlePage.gql';
import pageData from './ArticlePage.json';
import notFoundPageData from './ArticlePageNotFound.json';
import FallbackExclusiveContent from './FallbackExclusiveContent.json';

const ArticlePage = () => {
  const { render } = useComposablePage();
  const content = render(
    pageData,
    notFoundPageData,
    true,
    FallbackExclusiveContent
  );

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: ArticlePageQuery,
  isFound: (data) => data.brand.article,
})(ArticlePage);
